import { useTranslation } from 'react-i18next';
import { Tooltip as AntTooltip } from 'antd';
import * as Styled from './styles';
import tooltipIcon from 'assets/images/info-circle.png';

type TooltipProps = {
  children: string;
  isForLabel?: boolean;
};

export const Tooltip = ({ children, isForLabel = true }: TooltipProps) => {
  const { t } = useTranslation();

  return (
    <AntTooltip
      title={children}
      color="white"
      overlayInnerStyle={{ color: 'var(--v3-text-color)' }}
    >
      <Styled.TooltipIconWrapper $forLabel={isForLabel}>
        <Styled.TooltipIcon
          src={tooltipIcon}
          preview={false}
          alt={t('generic.tooltipIcon')}
        />
      </Styled.TooltipIconWrapper>
    </AntTooltip>
  );
};
